import { __read } from "tslib";
import { useQuery } from '@apollo/react-hooks';
import OrderSubsidyInfoRequest from '../../../../../__queries__/OrderSubsidyInfo.graphql';
import { findSubsidyForPassenger } from './utils';
import * as React from 'react';
export var useSubsidy = function (orderId) {
    var _a = __read(React.useState(null), 2), subsidyInfo = _a[0], setSubsidyInfo = _a[1];
    var _b = __read(React.useState(false), 2), loading = _b[0], setLoading = _b[1];
    var _c = __read(React.useState(null), 2), formValues = _c[0], setFormValues = _c[1];
    var _d = __read(React.useState(null), 2), subsidyError = _d[0], setSubsidyError = _d[1];
    var refetch = useQuery(OrderSubsidyInfoRequest.OrderSubsidyInfo, {
        skip: true
    }).refetch;
    var checkSubsidyForPassengers = function (passengers, formValues) {
        var passengersWithSubsidies = [];
        setLoading(true);
        setFormValues(formValues);
        var passengerValues = formValues['passengers'];
        passengerValues.forEach(function (values, index) {
            var _a;
            var passenger = passengers[index];
            if (passenger && values['subsidy']) {
                passengersWithSubsidies.push({
                    id: index.toString(),
                    values: passenger.values.map(function (value) {
                        var _a;
                        return {
                            type: value.type,
                            name: value.name,
                            value: (_a = values[value.name]) !== null && _a !== void 0 ? _a : null
                        };
                    }),
                    subsidyId: findSubsidyForPassenger(values, ((_a = passenger === null || passenger === void 0 ? void 0 : passenger.subsidyInfo) === null || _a === void 0 ? void 0 : _a.subsidies) || [])
                });
            }
        });
        refetch({
            id: orderId,
            travellers: passengersWithSubsidies
        })
            .then(function (data) {
            var _a;
            setSubsidyInfo((_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.OrderSubsidyInfo);
            setLoading(false);
            setSubsidyError(null);
        })
            .catch(function (error) {
            var _a, _b, _c, _d, _e, _f;
            setSubsidyError({
                message: (_f = (_c = (_b = (_a = error.graphQLErrors) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b['debugMessage']) !== null && _c !== void 0 ? _c : (_e = (_d = error.graphQLErrors) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e['message']) !== null && _f !== void 0 ? _f : 'internal error',
                name: 'Subsidy error'
            });
        })
            .finally(function () { return setLoading(false); });
    };
    var onClose = function () {
        setSubsidyInfo(null);
    };
    var clearError = function () { return setSubsidyError(null); };
    return {
        subsidyInfo: subsidyInfo,
        loading: loading,
        checkSubsidyForPassengers: checkSubsidyForPassengers,
        onClose: onClose,
        formValues: formValues,
        subsidyError: subsidyError,
        clearError: clearError
    };
};
